export default {
	// Custom Page Meta
	seo_meta_title_leaguepass: 'League Pass - NBA 생중게 경기 스트리밍 | NBA.com',
	seo_meta_desc_leaguepass: 'NBA League Pass로 NBA 경기를 생중계 및 VOD로 즐겨 보세요. 여기에서 계정에 로그인할 수 있습니다.',
	seo_meta_keywords_leaguepass: 'NBA 영상, NBA 하이라이트, 농구 영상, 최고의 플레이 영상, 덩크, 특집 영상',
	seo_meta_title_featured: 'NBA 경기 스트리밍 및 하이라이트 시청 | NBA.com',
	seo_meta_desc_featured: '무료 NBA 하이라이트 영상, 뉴스, 분석 콘텐츠를 즐겨 보세요. NBA TV 및 League Pass를 구독하고 원하는 기기에서 생중계 경기도 시청해 보세요.',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA TV - 실시간 경기 및 24시간 중계 시청  | NBA.com',
	seo_meta_desc_nbatv: 'NBA TV 실시간 경기를 즐기거나 대표적인 레전드 클래식 경기를 시청해 보세요. 스튜디오 프로그램과 24시간 제공되는 리그 분석 콘텐츠도 함께 즐겨 보세요.',
	seo_meta_keywords_nbatv: 'NBA TV 채널, The Beat, Hardwood Classics, NBA Live, Real NBA, NBA Game Time, Fantasy Insider, 다양한 스튜디오 쇼, The Jump',
	seo_meta_title_classicgames: 'NBA TV로 즐기는 클래식 경기와 다양한 콘텐츠 | NBA.com',
	seo_meta_desc_classicgames: 'NBA TV로 대표적인 NBA 매치업 경기를 시청해 보세요. NBA TV 생중계 경기는 물론 스튜디오 프로그램과 24시간 제공되는 리그 분석 콘텐츠도 확인하세요.',
	seo_meta_keywords_classicgames: '',
	seo_meta_pre_title_videolist: '콘텐츠 스트리밍  | NBA.com',
	seo_meta_title_videolist: '{0} 스트리밍 | NBA.com',
	seo_meta_desc_videolist: '{0} 영상을 시청하세요. NBA TV 및 League Pass를 구독하고 원하는 기기에서 생중계 경기를 즐겨 보세요.',
	seo_meta_title_videolist_show: 'NBA TV로 즐기는 {0} 스트리밍 | NBA.com',
	seo_meta_desc_videolist_show: '{0} 영상을 시청하세요. NBA TV 생중계 경기 시청은 물론 클래식 경기와 분석 콘텐츠도 이용해 보세요.',
	seo_meta_keywords_videolist_show: '',
	seo_meta_title_videolist_feed: '{0} 스트리밍 | NBA.com',
	seo_meta_desc_videolist_feed: '{0} 영상을 시청하세요. NBA TV 및 League Pass를 구독하고 원하는 기기에서 생중계 경기를 즐겨 보세요.',
	seo_meta_keywords_videolist_feed: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA TV로 즐기는 스튜디오 프로그램과 다양한 콘텐츠 | NBA.com',
	seo_meta_desc_shows: '최신 NBA TV 프로그램과 에피소드를 VOD로 시청해 보세요. NBA TV 생중계 경기 시청은 물론 클래식 경기와 분석 콘텐츠도 이용해 보세요.',
	seo_meta_keywords_shows: '',
	// Common Page Meta
	seo_meta_title_home: '홈 | NBA.com',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: '채널 | NBA.com',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: '채널 | NBA.com',
	seo_meta_pre_title_categories: '카테고리 | NBA.com',
	seo_meta_title_categories: '카테고리 | NBA.com',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: '카테고리 | NBA.com',
	seo_meta_title_category: '카테고리 | NBA.com',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: '영상 스트리밍 | NBA.com',
	seo_meta_pre_title_event: '이벤트 시청 | NBA.com',
	seo_meta_title_events: '이벤트 | NBA.com',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: '{0} 스트리밍 | NBA.com',
	seo_meta_desc_event: '{0} 영상을 시청하세요. NBA TV 및 League Pass를 구독하고 원하는 기기에서 생중계 경기를 즐겨 보세요.',
	seo_meta_keywords_event: '',
	seo_meta_title_search: '검색 | NBA.com',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: '페이지를 찾을 수 없음 | NBA.com',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: '경기 스트리밍 | NBA.com',
	seo_meta_title_game: '{0} 스트리밍 | NBA.com',
	seo_meta_desc_game: '{0} 영상을 시청하세요. NBA TV 및 League Pass를 구독하고 원하는 기기에서 생중계 경기를 즐겨 보세요.',
	seo_meta_keywords_game: '',
	seo_meta_title_video: '{0} 스트리밍 | NBA.com',
	seo_meta_desc_video: '{0} 영상을 시청하세요. NBA TV 및 League Pass를 구독하고 원하는 기기에서 생중계 경기를 즐겨 보세요.',
	seo_meta_keywords_video: 'NBA 영상, NBA 하이라이트, 농구 영상, 최고의 플레이 영상, 덩크, 특집 영상',
	seo_meta_title_episode: 'NBA TV로 즐기는 {0} 스트리밍 | NBA.com',
	seo_meta_desc_episode: '{0} 영상을 시청하세요. NBA TV 생중계 경기 시청은 물론 클래식 경기와 분석 콘텐츠도 이용해 보세요.',
	seo_meta_keywords_episode: 'NBA 영상, NBA 하이라이트, 농구 영상, 최고의 플레이 영상, 덩크, 특집 영상',
	seo_meta_title_channel: 'NBA TV 생중계 경기 | NBA.com',
	seo_meta_desc_channel: 'NBA TV Live는 매주 NBA 경기와 스튜디오 프로그램 및 농구 전문가의 경기 분석 내용을 생중계와 녹화 중계로 매일 24시간 스트리밍을 통해 전달하는 NBA TV 채널입니다.',
	seo_meta_keywords_channel: 'NBA TV 채널, The Beat, Hardwood Classics, NBA Live, Real NBA, NBA Game Time, Fantasy Insider, 다양한 스튜디오 쇼, The Jump',
	seo_meta_title_tvguide: 'NBA TV 경기 생중계 일정 | NBA.com',
	seo_meta_desc_tvguide: 'NBA TV로 원하는 기기에서 NBA TV 생중계 경기와 실시간 스튜디오 프로그램을 시청해 보세요. 스튜디오 프로그램 및 분석 VOD 콘텐츠도 놓치지 마세요.',
	seo_meta_keywords_tvguide: 'NBA TV 채널, The Beat, Hardwood Classics, NBA Live, Real NBA, NBA Game Time, Fantasy Insider, 다양한 스튜디오 쇼, The Jump',

	// Common
	timezone: 'ET',
	default_feed_error_message: '문제가 발생했습니다. 현재 콘텐츠를 이용할 수 없습니다. 나중에 다시 시도해 주세요.',
	watch_in_app: 'NBA APP에서 시청하기',
	ad_blocked_message: '광고 차단기가 감지되었습니다. NBA.com의 콘텐츠는 광고료로 운영됩니다. 콘텐츠 이용을 계속하려면 광고 차단기를 해제하시기 바랍니다.',

	// Item
	no_content: '콘텐츠 없음',
	see_more: '더 보기',
	now_playing: '지금 재생 중',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: '최대 수의 즐겨찾기 비디오에 도달했습니다. 추가하기 전에 일부 즐겨찾기 비디오를 제거하십시오.',
	item_live: '생중계',
	add_favourite_title: '즐겨찾기에 추가하기',
	remove_favourite_title: '즐겨찾기에서 삭제하기',
	// Channel: Schedule
	p_channel_live: '생중계',
	p_channel_schedule_title: 'NBA TV 일정',
	p_channel_schedule_watch: '시청',
	p_channel_live24x7_title: 'NBA TV 24시간 연중무휴',
	p_channel_live24x7_see_full_schedule: '전체 일정 보기',
	p_channel_live24x7_up_next: '다음 순서',
	p_channel_live24x7_on_demand: 'NBA TV: VOD',
	p_channel_live24x7_collection: '컬렉션',
	p_channel_live24x7_demand_1_logo_text: '오리지널 프로그램',
	p_channel_live24x7_demand_1_show_name: 'NBA TV 프로그램',
	p_channel_live24x7_demand_1_show_desc: 'Shaqtin’ a Fool, Beyond the Paint, Game Time, Basketball Stories 등의 오리지널 NBA TV 프로그램',
	p_channel_live24x7_demand_2_logo_text: '클래식 경기',
	p_channel_live24x7_demand_2_show_name: 'NBA | 레전드 경기',
	p_channel_live24x7_demand_2_show_desc: '2000년도 이후의 모든 파이널 매치업, 리그의 역사적인 순간들, 레전드 선수를 만날 수 있는 클래식 경기를 풀영상으로 시청하세요',

	// Channel: Clips
	p_channel_error_msg: '이용 불가',

	// Channel: detail
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: '일정',

	// NBA TV Shows:
	p_nba_tv_shows: 'NBA TV 프로그램',
	p_nba_tv_no_access_title: '경기 분석, 스튜디오 중계, 오리지널 프로그램 등의 다양한 정보와 소식을 24시간 연중무휴 업데이트 받으세요!',
	p_nba_tv_no_access_desc: '생중계 경기는 물론 다양한 프로그램과 클래식 경기를 VOD로 시청하세요.',
	p_nba_tv_no_access_note: '방송이 제한될 수 있습니다.',

	// tv show item
	tv_show_item_latest_episode: '최신 에피소드',
	tv_show_item_no_latest_episode: '최신 에피소드 없음',
	see_all: '모두 보기',
	// header
	header_menu_watch: '시청',
	header_menu_featured: '특집',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',

	// search
	players: '선수',
	videos: '영상',
	teams: '팀',
	most_searched: '인기 검색어',
	no_result: '데이터 없음',
	search_filter_type_most_relevant: '관련도',
	search_filter_type_most_viewed: '조회수',
	search_filter_type_most_recent: '최신',
	search_filter_type_last_30_days: '최근 30일',
	search_filter_type_last_6_months: '최근 6개월',
	search_result_label: '\'{keyword}\'에 대한 검색 결과',
	search_result_info: '{keyword}에 대한 모든 결과 보기',
	search_placeholder: '영상 라이브러리 검색',
	load_more: '더 보기',

	// button
	button_subscribe: '구독 신청',
	button_sign_in: '로그인',
	button_tv_provider: 'TV 서비스 업체 선택',

	// league page
	p_league_pass_no_access_title: '컴퓨터, 스마트폰, TV를 포함한 모든 기기에서 실시간 경기 시청과 다시보기 서비스를 즐겨 보세요!',
	p_league_pass_no_access_desc: '리그 전체 또는 즐겨찾기한 팀의 경기를 시청할 수도 있고, 단일 경기 서비스를 이용할 수도 있습니다. 다양한 옵션을 확인해 보세요.',
	p_league_pass_no_access_note: '이용 약관이 적용됩니다.',

	// Video
	category_title: '영상',
	p_video_playlist_title: '재생 목록:',
	p_video_episode_text: '에피소드',
	p_no_access_league_pass_title: 'NBA League Pass 구독하기',
	p_no_access_league_pass_premium_title: 'Unlock NBA League Pass Premium to watch:',
	p_no_access_league_pass_desc: '리그 전체 또는 즐겨찾기한 팀의 경기를 시청할 수도 있고, 단일 경기 서비스를 이용할 수도 있습니다. 다양한 옵션을 확인해 보세요.',
	p_no_access_league_pass_terms: '이용 약관이 적용됩니다.',
	p_no_access_league_pass_geo_desc: '현재 회원님이 계신 곳에서는 NBA League Pass 및 NBA TV로 해당 경기를 시청하실 수 없습니다. NBA League Pass 구독자는 경기 종료 3일 후에 제공되는 VOD를 시청해 주세요. 현지 방송 일정 및 채널에 대한 자세한 내용은 거주하고 계신 지역의 TV 및 라디오 방송사에 문의해 주시기 바랍니다.',
	p_no_access_league_pass_not_found_desc: '죄송합니다. 요청하신 페이지를 찾을 수 없습니다.',
	p_no_access_event_geo_desc: '미국이나 캐나다에서는 해당 방송이 방영되지 않습니다. 시청을 원할 경우 미국에서는 ESPN, 캐나다에서는 TSN 또는 Sportsnet을 이용하시기 바랍니다.',
	p_no_access_event_not_found_desc: '죄송합니다. 요청하신 페이지를 찾을 수 없습니다.',
	p_no_access_nba_tv_title: 'NBA TV 구독하기',
	p_no_access_nba_tv_desc: '생중계 경기는 물론 다양한 프로그램과 클래식 경기를 VOD로 시청하세요.',
	p_no_access_nba_tv_terms: '이용 약관이 적용됩니다.',
	p_no_access_nba_tv_geo_desc: '현재 회원님이 계신 곳에서는 NBA League Pass 및 NBA TV로 해당 경기를 시청하실 수 없습니다. NBA League Pass 구독자는 경기 종료 3일 후에 제공되는 VOD를 시청해 주세요. 현지 방송 일정 및 채널에 대한 자세한 내용은 거주하고 계신 지역의 TV 및 라디오 방송사에 문의해 주시기 바랍니다.',
	p_no_access_nba_tv_not_found_desc: '죄송합니다. 요청하신 페이지를 찾을 수 없습니다.',
	p_no_access_up_next: '다음 순서:',
	p_video_completed_title: '전체 재생 목록',
	p_video_completed_desc: '찾아보기로 이동하거나 당신을 위해 다음 재생 목록을 체크 아웃',
	p_video_share_to: '공유하기:',
	p_video_more_to_watch: '더 보기:',

	// Event
	p_event_section_title: '이벤트',
	p_event_playlist_title: '재생 목록:',
	p_event_button_watch: '시청',
	p_event_button_listen: '듣기',
	p_event_button_ticket: '티켓',

	// notfound page
	notfound: '죄송합니다. 요청한 페이지를 찾을 수 없습니다.',
	notfound_desc: 'URL 입력 시 실수가 없는지 확인하십시오. <br/> 또한 사이트 탐색이나 검색 도구를 사용하여 원하는 콘텐츠를 찾을 수도 있습니다.',

	// Modal - PCM
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: '귀하의 NBA League Pass 계정은 이용 가능한 최대 기기 수를 초과했습니다. 현재 기기에서 시청하려면 \'계속\'을 탭 하세요.',
	modal_pcm_custom: '계속',
	modal_pcm_close: '취소',
	modal_pcm_ok: '확인',

	// Modal - Unsupported
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: '기기에서 이 영상을 재생할 수 없습니다. 자세한 내용은 <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>여기</a>에서 확인해 주세요.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: '확인',
	modal_video_unsupported_ok: '확인',

	// FreeSample
	freesample_notice_time: '남은 시간',
	freesample_notice_title: '{0}분 접속을 즐기세요',
	freesample_notice_desc: '{0}분이 종료되고도 계속 접속하려면 완전한 League Pass 패키지에 가입하세요.',
	freesample_notice_subscribe_button: '구독 신청',
	freesample_notice_cancel_button: '언제든 취소 가능',
	freesample_popup_title: '접속이 종료되었습니다',
	freesample_popup_subtitle: '더 멋진 NBA 콘텐츠를 위해 League Pass에 가입하세요.',
	freesample_popup_link: '자세히 보기!',
	freesample_popup_get_minutes_button: '{0} 분 접속',

	// Video list
	reg_required_desc: '이 콘텐츠는 로그인 후 이용하실 수 있습니다.',
	favorite_teams_title: '즐겨찾기 팀',
	bookmarked_title: '저장됨',
	watch_history_title: '계속 시청하기',
	game_schedule_title: '경기 일정',
	recommended_title: '추천',
	season_text: '시즌',

	// profile page
	section_information_title: '내 정보',
	section_information_desc: '개인정보 업데이트',
	section_information_email: '이메일',
	section_information_email_update: '이메일 주소 업데이트',
	section_information_password: '비밀번호',
	section_information_password_update: '비밀번호 변경',
	section_information_social: '소셜 연결',
	section_information_nosocial_message: '연결된 계정이 없습니다.',
	section_information_firstname: '이름',
	section_information_lastname: '성',
	section_information_birth: '생년월일',
	section_information_country: '국가/지역',
	section_information_postalcode: '우편 번호',
	section_information_edit: '편집',
	section_tv_provider_title: '나의 TV 서비스 업체',
	section_tv_provider_desc: '이용 중인 TV 서비스 업체를 통해 실시간 경기 및 스트리밍 서비스에 액세스하세요.',
	section_tv_provider_faq: 'TV 서비스 업체 FAQ',
	section_tv_provider_sign_out: '로그아웃',
	section_tv_provider_sign_in: 'TV 서비스 업체 로그인',
	section_fantasy_title: '판타지리그',
	section_fantasy_desc: '판타지리그 계정 정보 보기',
	section_fantasy_displayname: '이름 표시하기',
	section_marketing_title: '이메일 설정',
	section_marketing_desc: '마케팅 커뮤니케이션 및 사용자 개인정보 설정 보기',
	section_marketing_newsletters: '뉴스레터',
	section_marketing_message: 'NBA 메시지 및 광고',
	section_marketing_newsletters_desc_1: '이메일로 확인하는 데일리 NBA 뉴스',
	section_marketing_newsletters_desc_2: 'NBA 공식 마이너리그가 제공하는 NBA G 리그 뉴스 및 기능',
	section_marketing_newsletters_desc_3: 'NBA 청소년 농구 이니셔티브가 제공하는 주니어 NBA 뉴스 및 콘텐츠',
	section_marketing_newsletters_desc_4: 'NBA 앱의 최신 기능과 League Pass 업데이트 및 할인 혜택',
	section_marketing_newsletters_desc_5: 'NBA의 특별 티켓 할인 혜택, 파트너 혜택, 이벤트 및 상품 할인',
	section_marketing_newsletters_desc_6: '매주 이메일로 확인하는 엄선된 NBA 뉴스 및 콘텐츠',
	section_marketing_newsletters_desc_7: 'WNBA와 파트너사가 제공하는 WNBA 뉴스 및 할인 혜택',
	section_marketing_personal_title: '나의 개인정보',
	section_marketing_personal_desc: 'NBA의 메시지 전송을 비롯해, NBA 및 NBA 파트너사의 제품과 서비스 광고 수신을 위한 개인정보 사용을 허용합니다.',
	section_marketing_update_button: '마케팅 설정 업데이트',
	section_marketing_update_success: '설정이 업데이트되었습니다.',
	section_ccpa_title: '개인정보를 판매하지 않습니다',

	// profile edit modal
	email_modal_title: '이메일 주소 업데이트',
	email_modal_new_email_label: '새로운 이메일 주소',
	email_modal_update: '업데이트',
	email_modal_cancel: '취소',
	password_modal_title: '비밀번호 변경',
	password_modal_current_label: '현재 비밀번호:',
	password_modal_new_label: '새 비밀번호:',
	password_modal_confirm_label: '비밀번호 확인',
	password_modal_update: '업데이트',
	password_modal_cancel: '취소',
	personal_modal_title: '개인정보 업데이트',
	personal_modal_email: '이메일',
	personal_modal_password: '비밀번호',
	personal_modal_birth: '생년월일',
	personal_modal_social: '소셜 연결',
	personal_modal_firstname: '이름',
	personal_modal_lastname: '성',
	personal_modal_country: '국가/지역',
	personal_modal_postalcode: '우편 번호',
	personal_modal_zipcode: '우편 번호',
	personal_modal_postalcode_invalid_message: '올바른 우편 번호여야 합니다',
	personal_modal_zipcode_invalid_message: '올바른 우편 번호여야 합니다',
	personal_modal_update: '업데이트',
	personal_modal_cancel: '취소',

	// payflow
	payflow_profile_name: '이름',
	payflow_profile_email: '이메일',

	// account page
	header_menu_account_my_account: '내 계정',
	header_menu_account_manage_account: '계정 관리',
	header_menu_account_favorite_teams: '즐겨찾기 팀',
	header_menu_account_favorite_players: '즐겨찾기 선수',
	header_menu_account_viewing_history: '시청 기록',
};
